import type { ReactElement } from 'react';
import { useUIDSeed } from 'react-uid';
import RecipeSkeleton from './RecipeSkeleton';

function SkuGallerySkeleton(): ReactElement {
  const seed = useUIDSeed();

  return (
    <div className="c-recipe-gallery">
      <div className="c-recipe-gallery__scroll">
        <div className="row">
          {[...Array(4)].map((el, i) => (
            <RecipeSkeleton key={seed(i)} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default SkuGallerySkeleton;
